import { useContext, useEffect, useState } from "react";
import { AuthType } from "../../shared/constants/AppEnums";
import { defaultUser } from "../../shared/constants/AppConst";
import jwtAxios from "../services/ApiConfig";
import { AuthUser } from "../../types/models/AuthUser";
import {
  fetchStart,
  fetchSuccess,
  useInfoViewActionsContext,
} from "../core/InfoView/InfoViewContext";
import AppContext from "./AppContext";
import AppContextPropsType from "../../types/AppContextPropsType";

export const useAuthToken = (): [boolean, AuthUser | null] => {
  const [loading, setLoading] = useState(true);
  const { user, updateAuthUser } = useContext<AppContextPropsType>(AppContext);
  const dispatch = useInfoViewActionsContext()!;

  useEffect(() => {
    const validateAuth = async () => {
      dispatch(fetchStart());

      let PatientDetails = localStorage.getItem("AdminDetails");
      let token = "";
      let userdetails: any;
      if (PatientDetails) {
        userdetails = JSON.parse(PatientDetails);
        token = userdetails["identificationKey"];
      }

      //  const token = localStorage.getItem('token');
      if (!token) {
        dispatch(fetchSuccess());
        return;
      }
      jwtAxios.defaults.headers.common["x-auth-token"] = token;
      try {
        //const res = await jwtAxios.get("/auth");

        //   dispatch(fetchSuccess());
        updateAuthUser({
          authType: AuthType.JWT_AUTH,
          displayName: userdetails["firstName"],
          email: userdetails["email"],
          role: ["user", "admin"],
          token: token,
          uid: userdetails["docid"],
          photoURL: userdetails["photo"],
        });
        return;
      } catch (err) {
        // dispatch(fetchSuccess());
        return;
      }
    };

    const checkAuth = () => {
      Promise.all([validateAuth()]).then(() => {
        setLoading(false);
      });
    };
    checkAuth();
  }, [dispatch, updateAuthUser]);

  return [loading, user];
};

export const useAuthUser = (): AuthUser | null => {
  const { user } = useContext<AppContextPropsType>(AppContext);
  if (user) {
    return user;
  }
  return null;
};

export const getUserToken = () => {
  let PatientDetails = localStorage.getItem("AdminDetails");
  let token = "";
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    token = userdetails["identificationKey"];
  }

  return token;
};

export const getUserName = () => {
  let PatientDetails = localStorage.getItem("AdminDetails");
  let userName = "";
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    userName = userdetails["firstName"] + " " + userdetails["lastName"];
  }

  return userName;
};
export const getUserEmail = () => {
  let PatientDetails = localStorage.getItem("AdminDetails");
  let email = "";
  let userdetails: any;
  if (PatientDetails) {
    userdetails = JSON.parse(PatientDetails);
    email = userdetails["email"];
  }

  return email;
};

export const getUserId = () => {
  let AdminDetails = localStorage.getItem("AdminDetails");
  let userId = "";
  let userdetails: any;
  if (AdminDetails) {
    userdetails = JSON.parse(AdminDetails);
    userId = userdetails["id"] || userdetails["_id"] || "";
  }

  return userId;
};

export const getUserRoleTypeRank = () => {
  let userDetails = localStorage.getItem("AdminDetails");
  let roleTypeRank: number = 0;
  let details: any;
  if (userDetails) {
    details = JSON.parse(userDetails);
    roleTypeRank = details["roletyperank"];
  }

  return roleTypeRank;
}